import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function InstallApp() {
    const { t } = useTranslation();

    return (
        <Box
            component="section"
            sx={{
                py: { xs: 2.5, md: 3 },
                px: { xs: 2, md: 4 },
                backgroundColor: '#ffffff',
                borderTop: '1px solid rgba(4, 140, 236, 0.16)',
                borderBottom: '1px solid rgba(4, 140, 236, 0.16)',
            }}
        >
            <Box
                sx={{
                    maxWidth: '760px',
                    margin: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1.25,
                    textAlign: 'center',
                }}
            >
                <Typography
                    sx={{
                        fontFamily: 'Barlow, sans-serif',
                        fontSize: { xs: '0.95rem', md: '1.05rem' },
                        fontWeight: 700,
                        color: '#1a202c',
                        letterSpacing: '0.01em',
                    }}
                >
                    {t('BannerApp04')}
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: { xs: 1, sm: 1.5 },
                        flexWrap: 'wrap',
                    }}
                >
                    <Box
                        component="a"
                        href="https://apps.apple.com/app/icoachbasketball-com/6478594779"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Download on the App Store"
                        sx={{
                            display: 'block',
                            lineHeight: 0,
                            transition: 'transform 0.2s ease, opacity 0.2s ease',
                            '&:hover': {
                                transform: 'scale(1.04)',
                                opacity: 0.9,
                            },
                        }}
                    >
                        <Box
                            component="img"
                            src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                            alt="Download on the App Store"
                            sx={{
                                height: { xs: 42, sm: 48 },
                                width: 'auto',
                            }}
                        />
                    </Box>

                    <Box
                        component="a"
                        href="https://play.google.com/store/search?q=icoachbasketball&c=apps&hl"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Get it on Google Play"
                        sx={{
                            display: 'block',
                            lineHeight: 0,
                            transition: 'transform 0.2s ease, opacity 0.2s ease',
                            '&:hover': {
                                transform: 'scale(1.04)',
                                opacity: 0.9,
                            },
                        }}
                    >
                        <Box
                            component="img"
                            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                            alt="Get it on Google Play"
                            sx={{
                                height: { xs: 63, sm: 72 },
                                width: 'auto',
                            }}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};